import { render, staticRenderFns } from "./AppEmailListMultipleRecipient.vue?vue&type=template&id=6dc1467a&scoped=true&"
import script from "./AppEmailListMultipleRecipient.vue?vue&type=script&lang=js&"
export * from "./AppEmailListMultipleRecipient.vue?vue&type=script&lang=js&"
import style0 from "./AppEmailListMultipleRecipient.vue?vue&type=style&index=0&id=6dc1467a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc1467a",
  null
  
)

export default component.exports